import axios from 'axios';

const api = axios.create({
  baseURL: '/',
  withCredentials: true,
});

// NOTE: No general 401 interceptor redirect here — that caused an infinite loop
// on the login page because /auth/me returns 401 for unauthenticated users,
// which triggered a redirect to /login, which loaded and called /auth/me again.
// Auth redirects are handled by PrivateRoute in App.jsx instead.
//
// The ONE exception: an idle timeout, which the server marks with an explicit
// code. A plain 401 (not signed in) never carries it, so this cannot re-create
// the loop — and the redirect is skipped on /login for belt and braces.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const code = err?.response?.data?.code;
    if (err?.response?.status === 401 && code === 'session_timeout'
        && window.location.pathname !== '/login') {
      window.location.href = '/login?timeout=1';
    }
    return Promise.reject(err);
  }
);

export default api;
